var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "payment-box" }, [
      _c("div", { staticClass: "transaction-msg fail" }, [
        _c("span"),
        _vm._v(
          "\n    Your payment has failed. Please try again, or choose another payment option.\n  "
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }